import _regeneratorRuntime from "/tmp/aauthui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _createForOfIteratorHelper from "/tmp/aauthui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _asyncToGenerator from "/tmp/aauthui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/tmp/aauthui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/tmp/aauthui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import * as asn1js from "asn1js";
import { getParametersValue, utilFromBase, utilToBase, bufferToHexCodes, toBase64, fromBase64, arrayBufferToString, stringToArrayBuffer } from "pvutils";
import { ByteStream, SeqStream } from "bytestreamjs";
import { getCrypto, getEngine } from "./common.js";
import PublicKeyInfo from "./PublicKeyInfo.js"; //**************************************************************************************

export var SignedCertificateTimestamp = /*#__PURE__*/function () {
  //**********************************************************************************

  /**
   * Constructor for SignedCertificateTimestamp class
   * @param {Object} [parameters={}]
   * @param {Object} [parameters.schema] asn1js parsed value to initialize the class from
   */
  function SignedCertificateTimestamp() {
    var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, SignedCertificateTimestamp);

    //region Internal properties of the object

    /**
     * @type {number}
     * @desc version
     */
    this.version = getParametersValue(parameters, "version", SignedCertificateTimestamp.defaultValues("version"));
    /**
     * @type {ArrayBuffer}
     * @desc logID
     */

    this.logID = getParametersValue(parameters, "logID", SignedCertificateTimestamp.defaultValues("logID"));
    /**
     * @type {Date}
     * @desc timestamp
     */

    this.timestamp = getParametersValue(parameters, "timestamp", SignedCertificateTimestamp.defaultValues("timestamp"));
    /**
     * @type {ArrayBuffer}
     * @desc extensions
     */

    this.extensions = getParametersValue(parameters, "extensions", SignedCertificateTimestamp.defaultValues("extensions"));
    /**
     * @type {string}
     * @desc hashAlgorithm
     */

    this.hashAlgorithm = getParametersValue(parameters, "hashAlgorithm", SignedCertificateTimestamp.defaultValues("hashAlgorithm"));
    /**
     * @type {string}
     * @desc signatureAlgorithm
     */

    this.signatureAlgorithm = getParametersValue(parameters, "signatureAlgorithm", SignedCertificateTimestamp.defaultValues("signatureAlgorithm"));
    /**
     * @type {Object}
     * @desc signature
     */

    this.signature = getParametersValue(parameters, "signature", SignedCertificateTimestamp.defaultValues("signature")); //endregion
    //region If input argument array contains "schema" for this object

    if ("schema" in parameters) this.fromSchema(parameters.schema); //endregion
    //region If input argument array contains "stream"

    if ("stream" in parameters) this.fromStream(parameters.stream); //endregion
  } //**********************************************************************************

  /**
   * Return default values for all class members
   * @param {string} memberName String name for a class member
   */


  _createClass(SignedCertificateTimestamp, [{
    key: "fromSchema",
    //**********************************************************************************

    /**
     * Convert parsed asn1js object into current class
     * @param {!Object} schema
     */
    value: function fromSchema(schema) {
      if (schema instanceof asn1js.RawData === false) throw new Error("Object's schema was not verified against input data for SignedCertificateTimestamp");
      var seqStream = new SeqStream({
        stream: new ByteStream({
          buffer: schema.data
        })
      });
      this.fromStream(seqStream);
    } //**********************************************************************************

    /**
     * Convert SeqStream data into current class
     * @param {!SeqStream} stream
     */

  }, {
    key: "fromStream",
    value: function fromStream(stream) {
      var blockLength = stream.getUint16();
      this.version = stream.getBlock(1)[0];

      if (this.version === 0) {
        this.logID = new Uint8Array(stream.getBlock(32)).buffer.slice(0);
        this.timestamp = new Date(utilFromBase(new Uint8Array(stream.getBlock(8)), 8)); //region Extensions

        var extensionsLength = stream.getUint16();
        this.extensions = new Uint8Array(stream.getBlock(extensionsLength)).buffer.slice(0); //endregion
        //region Hash algorithm

        switch (stream.getBlock(1)[0]) {
          case 0:
            this.hashAlgorithm = "none";
            break;

          case 1:
            this.hashAlgorithm = "md5";
            break;

          case 2:
            this.hashAlgorithm = "sha1";
            break;

          case 3:
            this.hashAlgorithm = "sha224";
            break;

          case 4:
            this.hashAlgorithm = "sha256";
            break;

          case 5:
            this.hashAlgorithm = "sha384";
            break;

          case 6:
            this.hashAlgorithm = "sha512";
            break;

          default:
            throw new Error("Object's stream was not correct for SignedCertificateTimestamp");
        } //endregion
        //region Signature algorithm


        switch (stream.getBlock(1)[0]) {
          case 0:
            this.signatureAlgorithm = "anonymous";
            break;

          case 1:
            this.signatureAlgorithm = "rsa";
            break;

          case 2:
            this.signatureAlgorithm = "dsa";
            break;

          case 3:
            this.signatureAlgorithm = "ecdsa";
            break;

          default:
            throw new Error("Object's stream was not correct for SignedCertificateTimestamp");
        } //endregion
        //region Signature


        var signatureLength = stream.getUint16();
        var signatureData = new Uint8Array(stream.getBlock(signatureLength)).buffer.slice(0);
        var asn1 = asn1js.fromBER(signatureData);
        if (asn1.offset === -1) throw new Error("Object's stream was not correct for SignedCertificateTimestamp");
        this.signature = asn1.result; //endregion

        if (blockLength !== 47 + extensionsLength + signatureLength) throw new Error("Object's stream was not correct for SignedCertificateTimestamp");
      }
    } //**********************************************************************************

    /**
     * Convert current object to asn1js object and set correct values
     * @returns {Object} asn1js object
     */

  }, {
    key: "toSchema",
    value: function toSchema() {
      var stream = this.toStream();
      return new asn1js.RawData({
        data: stream.stream.buffer
      });
    } //**********************************************************************************

    /**
     * Convert current object to SeqStream data
     * @returns {SeqStream} SeqStream object
     */

  }, {
    key: "toStream",
    value: function toStream() {
      var stream = new SeqStream();
      stream.appendUint16(47 + this.extensions.byteLength + this.signature.valueBeforeDecode.byteLength);
      stream.appendChar(this.version);
      stream.appendView(new Uint8Array(this.logID));
      var timeBuffer = new ArrayBuffer(8);
      var timeView = new Uint8Array(timeBuffer);
      var baseArray = utilToBase(this.timestamp.valueOf(), 8);
      timeView.set(new Uint8Array(baseArray), 8 - baseArray.byteLength);
      stream.appendView(timeView);
      stream.appendUint16(this.extensions.byteLength);
      if (this.extensions.byteLength) stream.appendView(new Uint8Array(this.extensions));

      var _hashAlgorithm;

      switch (this.hashAlgorithm.toLowerCase()) {
        case "none":
          _hashAlgorithm = 0;
          break;

        case "md5":
          _hashAlgorithm = 1;
          break;

        case "sha1":
          _hashAlgorithm = 2;
          break;

        case "sha224":
          _hashAlgorithm = 3;
          break;

        case "sha256":
          _hashAlgorithm = 4;
          break;

        case "sha384":
          _hashAlgorithm = 5;
          break;

        case "sha512":
          _hashAlgorithm = 6;
          break;

        default:
          throw new Error("Incorrect data for hashAlgorithm: ".concat(this.hashAlgorithm));
      }

      stream.appendChar(_hashAlgorithm);

      var _signatureAlgorithm;

      switch (this.signatureAlgorithm.toLowerCase()) {
        case "anonymous":
          _signatureAlgorithm = 0;
          break;

        case "rsa":
          _signatureAlgorithm = 1;
          break;

        case "dsa":
          _signatureAlgorithm = 2;
          break;

        case "ecdsa":
          _signatureAlgorithm = 3;
          break;

        default:
          throw new Error("Incorrect data for signatureAlgorithm: ".concat(this.signatureAlgorithm));
      }

      stream.appendChar(_signatureAlgorithm);

      var _signature = this.signature.toBER(false);

      stream.appendUint16(_signature.byteLength);
      stream.appendView(new Uint8Array(_signature));
      return stream;
    } //**********************************************************************************

    /**
     * Convertion for the class to JSON object
     * @returns {Object}
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        version: this.version,
        logID: bufferToHexCodes(this.logID),
        timestamp: this.timestamp,
        extensions: bufferToHexCodes(this.extensions),
        hashAlgorithm: this.hashAlgorithm,
        signatureAlgorithm: this.signatureAlgorithm,
        signature: this.signature.toJSON()
      };
    } //**********************************************************************************

    /**
     * Verify SignedCertificateTimestamp for specific input data
     * @param {Object[]} logs Array of objects with information about each CT Log (like here: https://ct.grahamedgecombe.com/logs.json)
     * @param {String} logs.log_id Identifier of the CT Log encoded in BASE-64 format
     * @param {String} logs.key Public key of the CT Log encoded in BASE-64 format
     * @param {ArrayBuffer} data Data to verify signature against. Could be encoded Certificate or encoded PreCert
     * @param {Number} [dataType=0] Type = 0 (data is encoded Certificate), type = 1 (data is encoded PreCert)
     * @return {Promise<void>}
     */

  }, {
    key: "verify",
    value: function () {
      var _verify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(logs, data) {
        var dataType,
            logId,
            publicKeyBase64,
            publicKeyInfo,
            stream,
            _iterator,
            _step,
            log,
            asn1,
            timeBuffer,
            timeView,
            baseArray,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dataType = _args.length > 2 && _args[2] !== undefined ? _args[2] : 0;
                //region Initial variables
                logId = toBase64(arrayBufferToString(this.logID));
                publicKeyBase64 = null;
                stream = new SeqStream(); //endregion
                //region Found and init public key

                _iterator = _createForOfIteratorHelper(logs);
                _context.prev = 5;

                _iterator.s();

              case 7:
                if ((_step = _iterator.n()).done) {
                  _context.next = 14;
                  break;
                }

                log = _step.value;

                if (!(log.log_id === logId)) {
                  _context.next = 12;
                  break;
                }

                publicKeyBase64 = log.key;
                return _context.abrupt("break", 14);

              case 12:
                _context.next = 7;
                break;

              case 14:
                _context.next = 19;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](5);

                _iterator.e(_context.t0);

              case 19:
                _context.prev = 19;

                _iterator.f();

                return _context.finish(19);

              case 22:
                if (!(publicKeyBase64 === null)) {
                  _context.next = 24;
                  break;
                }

                throw new Error("Public key not found for CT with logId: ".concat(logId));

              case 24:
                asn1 = asn1js.fromBER(stringToArrayBuffer(fromBase64(publicKeyBase64)));

                if (!(asn1.offset === -1)) {
                  _context.next = 27;
                  break;
                }

                throw new Error("Incorrect key value for CT Log with logId: ".concat(logId));

              case 27:
                publicKeyInfo = new PublicKeyInfo({
                  schema: asn1.result
                }); //endregion
                //region Initialize signed data block

                stream.appendChar(0x00); // sct_version

                stream.appendChar(0x00); // signature_type = certificate_timestamp

                timeBuffer = new ArrayBuffer(8);
                timeView = new Uint8Array(timeBuffer);
                baseArray = utilToBase(this.timestamp.valueOf(), 8);
                timeView.set(new Uint8Array(baseArray), 8 - baseArray.byteLength);
                stream.appendView(timeView);
                stream.appendUint16(dataType);
                if (dataType === 0) stream.appendUint24(data.byteLength);
                stream.appendView(new Uint8Array(data));
                stream.appendUint16(this.extensions.byteLength);
                if (this.extensions.byteLength !== 0) stream.appendView(new Uint8Array(this.extensions)); //endregion
                //region Perform verification

                return _context.abrupt("return", getEngine().subtle.verifyWithPublicKey(stream._stream._buffer.slice(0, stream._length), {
                  valueBlock: {
                    valueHex: this.signature.toBER(false)
                  }
                }, publicKeyInfo, {
                  algorithmId: ""
                }, "SHA-256"));

              case 41:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 16, 19, 22]]);
      }));

      function verify(_x, _x2) {
        return _verify.apply(this, arguments);
      }

      return verify;
    }() //**********************************************************************************

  }], [{
    key: "defaultValues",
    value: function defaultValues(memberName) {
      switch (memberName) {
        case "version":
          return 0;

        case "logID":
        case "extensions":
          return new ArrayBuffer(0);

        case "timestamp":
          return new Date(0);

        case "hashAlgorithm":
        case "signatureAlgorithm":
          return "";

        case "signature":
          return new asn1js.Any();

        default:
          throw new Error("Invalid member name for SignedCertificateTimestamp class: ".concat(memberName));
      }
    }
  }]);

  return SignedCertificateTimestamp;
}(); //**************************************************************************************

/**
 * Class from RFC6962
 */

var SignedCertificateTimestampList = /*#__PURE__*/function () {
  //**********************************************************************************

  /**
   * Constructor for SignedCertificateTimestampList class
   * @param {Object} [parameters={}]
   * @param {Object} [parameters.schema] asn1js parsed value to initialize the class from
   */
  function SignedCertificateTimestampList() {
    var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, SignedCertificateTimestampList);

    //region Internal properties of the object

    /**
     * @type {Array.<SignedCertificateTimestamp>}
     * @desc timestamps
     */
    this.timestamps = getParametersValue(parameters, "timestamps", SignedCertificateTimestampList.defaultValues("timestamps")); //endregion
    //region If input argument array contains "schema" for this object

    if ("schema" in parameters) this.fromSchema(parameters.schema); //endregion
  } //**********************************************************************************

  /**
   * Return default values for all class members
   * @param {string} memberName String name for a class member
   */


  _createClass(SignedCertificateTimestampList, [{
    key: "fromSchema",
    //**********************************************************************************

    /**
     * Convert parsed asn1js object into current class
     * @param {!Object} schema
     */
    value: function fromSchema(schema) {
      //region Check the schema is valid
      if (schema instanceof asn1js.OctetString === false) throw new Error("Object's schema was not verified against input data for SignedCertificateTimestampList"); //endregion
      //region Get internal properties from parsed schema

      var seqStream = new SeqStream({
        stream: new ByteStream({
          buffer: schema.valueBlock.valueHex
        })
      });
      var dataLength = seqStream.getUint16();
      if (dataLength !== seqStream.length) throw new Error("Object's schema was not verified against input data for SignedCertificateTimestampList");

      while (seqStream.length) {
        this.timestamps.push(new SignedCertificateTimestamp({
          stream: seqStream
        }));
      } //endregion

    } //**********************************************************************************

    /**
     * Convert current object to asn1js object and set correct values
     * @returns {Object} asn1js object
     */

  }, {
    key: "toSchema",
    value: function toSchema() {
      //region Initial variables
      var stream = new SeqStream();
      var overallLength = 0;
      var timestampsData = []; //endregion
      //region Get overall length

      var _iterator2 = _createForOfIteratorHelper(this.timestamps),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _timestamp = _step2.value;

          var timestampStream = _timestamp.toStream();

          timestampsData.push(timestampStream);
          overallLength += timestampStream.stream.buffer.byteLength;
        } //endregion

      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      stream.appendUint16(overallLength); //region Set data from all timestamps

      for (var _i = 0, _timestampsData = timestampsData; _i < _timestampsData.length; _i++) {
        var timestamp = _timestampsData[_i];
        stream.appendView(timestamp.stream.view);
      } //endregion


      return new asn1js.OctetString({
        valueHex: stream.stream.buffer.slice(0)
      });
    } //**********************************************************************************

    /**
     * Convertion for the class to JSON object
     * @returns {Object}
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        timestamps: Array.from(this.timestamps, function (element) {
          return element.toJSON();
        })
      };
    } //**********************************************************************************

  }], [{
    key: "defaultValues",
    value: function defaultValues(memberName) {
      switch (memberName) {
        case "timestamps":
          return [];

        default:
          throw new Error("Invalid member name for SignedCertificateTimestampList class: ".concat(memberName));
      }
    } //**********************************************************************************

    /**
     * Compare values with default values for all class members
     * @param {string} memberName String name for a class member
     * @param {*} memberValue Value to compare with default value
     */

  }, {
    key: "compareWithDefault",
    value: function compareWithDefault(memberName, memberValue) {
      switch (memberName) {
        case "timestamps":
          return memberValue.length === 0;

        default:
          throw new Error("Invalid member name for SignedCertificateTimestampList class: ".concat(memberName));
      }
    } //**********************************************************************************

    /**
     * Return value of pre-defined ASN.1 schema for current class
     *
     * ASN.1 schema:
     * ```asn1
     * SignedCertificateTimestampList ::= OCTET STRING
     * ```
     *
     * @param {Object} parameters Input parameters for the schema
     * @returns {Object} asn1js schema object
     */

  }, {
    key: "schema",
    value: function schema() {
      var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      /**
       * @type {Object}
       * @property {string} [blockName]
       * @property {string} [optional]
       */
      var names = getParametersValue(parameters, "names", {});
      if ("optional" in names === false) names.optional = false;
      return new asn1js.OctetString({
        name: names.blockName || "SignedCertificateTimestampList",
        optional: names.optional
      });
    }
  }]);

  return SignedCertificateTimestampList;
}(); //**************************************************************************************

/**
 * Verify SignedCertificateTimestamp for specific certificate content
 * @param {Certificate} certificate Certificate for which verification would be performed
 * @param {Certificate} issuerCertificate Certificate of the issuer of target certificate
 * @param {Object[]} logs Array of objects with information about each CT Log (like here: https://ct.grahamedgecombe.com/logs.json)
 * @param {String} logs.log_id Identifier of the CT Log encoded in BASE-64 format
 * @param {String} logs.key Public key of the CT Log encoded in BASE-64 format
 * @param {Number} [index=-1] Index of SignedCertificateTimestamp inside SignedCertificateTimestampList (for -1 would verify all)
 * @return {Array} Array of verification results
 */


export { SignedCertificateTimestampList as default };
export function verifySCTsForCertificate(_x3, _x4, _x5) {
  return _verifySCTsForCertificate.apply(this, arguments);
} //**********************************************************************************

function _verifySCTsForCertificate() {
  _verifySCTsForCertificate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(certificate, issuerCertificate, logs) {
    var index,
        parsedValue,
        tbs,
        issuerId,
        stream,
        preCert,
        crypto,
        i,
        verifyArray,
        _iterator3,
        _step3,
        timestamp,
        verifyResult,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            index = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : -1;
            //region Initial variables
            parsedValue = null;
            stream = new SeqStream();
            //endregion
            //region Get a "crypto" extension
            crypto = getCrypto();

            if (!(typeof crypto === "undefined")) {
              _context2.next = 6;
              break;
            }

            return _context2.abrupt("return", Promise.reject("Unable to create WebCrypto object"));

          case 6:
            i = 0;

          case 7:
            if (!(i < certificate.extensions.length)) {
              _context2.next = 19;
              break;
            }

            _context2.t0 = certificate.extensions[i].extnID;
            _context2.next = _context2.t0 === "1.3.6.1.4.1.11129.2.4.2" ? 11 : 16;
            break;

          case 11:
            parsedValue = certificate.extensions[i].parsedValue;

            if (!(parsedValue.timestamps.length === 0)) {
              _context2.next = 14;
              break;
            }

            throw new Error("Nothing to verify in the certificate");

          case 14:
            certificate.extensions.splice(i, 1);
            return _context2.abrupt("break", 16);

          case 16:
            i++;
            _context2.next = 7;
            break;

          case 19:
            if (!(parsedValue === null)) {
              _context2.next = 21;
              break;
            }

            throw new Error("No SignedCertificateTimestampList extension in the specified certificate");

          case 21:
            //endregion
            //region Prepare modifier TBS value
            tbs = certificate.encodeTBS().toBER(false); //endregion
            //region Initialize "issuer_key_hash" value

            _context2.next = 24;
            return crypto.digest({
              name: "SHA-256"
            }, new Uint8Array(issuerCertificate.subjectPublicKeyInfo.toSchema().toBER(false)));

          case 24:
            issuerId = _context2.sent;
            //endregion
            //region Make final "PreCert" value
            stream.appendView(new Uint8Array(issuerId));
            stream.appendUint24(tbs.byteLength);
            stream.appendView(new Uint8Array(tbs));
            preCert = stream._stream._buffer.slice(0, stream._length); //endregion
            //region Call verification function for specified index

            if (!(index === -1)) {
              _context2.next = 51;
              break;
            }

            verifyArray = [];
            _iterator3 = _createForOfIteratorHelper(parsedValue.timestamps);
            _context2.prev = 32;

            _iterator3.s();

          case 34:
            if ((_step3 = _iterator3.n()).done) {
              _context2.next = 42;
              break;
            }

            timestamp = _step3.value;
            _context2.next = 38;
            return timestamp.verify(logs, preCert, 1);

          case 38:
            verifyResult = _context2.sent;
            verifyArray.push(verifyResult);

          case 40:
            _context2.next = 34;
            break;

          case 42:
            _context2.next = 47;
            break;

          case 44:
            _context2.prev = 44;
            _context2.t1 = _context2["catch"](32);

            _iterator3.e(_context2.t1);

          case 47:
            _context2.prev = 47;

            _iterator3.f();

            return _context2.finish(47);

          case 50:
            return _context2.abrupt("return", verifyArray);

          case 51:
            if (index >= parsedValue.timestamps.length) index = parsedValue.timestamps.length - 1;
            _context2.next = 54;
            return parsedValue.timestamps[index].verify(logs, preCert, 1);

          case 54:
            _context2.t2 = _context2.sent;
            return _context2.abrupt("return", [_context2.t2]);

          case 56:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[32, 44, 47, 50]]);
  }));
  return _verifySCTsForCertificate.apply(this, arguments);
}